import { northAmericanStatesProvinces } from "../constants/northAmericanStatesProvinces";

const normalizeRegionName = (value) => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toUpperCase()
  .trim();

const createStateLookupMap = () => {
  const map = {};

  Object.entries(northAmericanStatesProvinces).forEach(([country, regions]) => {
    const isMetric = country !== 'us';

    Object.values(regions).forEach((regionNames) => {
      regionNames.forEach((regionName) => {
        map[normalizeRegionName(regionName)] = {
          country,
          isMetric
        };
      });
    });
  });

  return map;
};

const stateLookupMap = createStateLookupMap();

/**
 * Resolves a state name or abbreviation to its country and unit system.
 *
 * @param {string} state - State or province name/abbreviation
 * @returns {object} Object with country ('us'|'ca'|'mx'|'unknown') and isMetric (boolean|null)
 */
function findUnitSystemByState(state) {
  if (!state) {
    return {
      country: 'unknown',
      isMetric: null
    };
  }

  const normalized = normalizeRegionName(state);
  const result = stateLookupMap[normalized];

  return result || {
    country: 'unknown',
    isMetric: null
  };
}

function convertMilesToKilometers(miles) {
  const kilometers = miles * 1.60934;
  return kilometers.toFixed(2); // Round to 2 decimal places
}

function convertKilometersToMiles(kilometers) {
  const miles = kilometers / 1.60934;
  return miles.toFixed(2); // Round to 2 decimal places
}

export { findUnitSystemByState, convertMilesToKilometers, convertKilometersToMiles };